import { PLAYER_HAND, DEALER_HAND, } from './strings';

export const INITIAL_STATE = {
  [PLAYER_HAND]: { cards: [], },
  [DEALER_HAND]: { cards: [], },
};
